import React from 'react';

import { Box, Typography } from '@mui/material';

import { displayDateString } from '../../../../../../common/utils/DateUtils';
import { UserLog } from '../../../../../types/UserLog';

type Props = {
  userLog: UserLog;
};

const UserLogCell: React.FC<Props> = ({ userLog }) => {
  return (
    <Box className='table-view-cell-container'>
      <Box
        sx={{
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: '8px',
        }}
        className='row'
      >
        <Typography fontFamily={'SFProDisplay-Regular'} color='text.secondary'>
          Date:
        </Typography>
        <Typography fontFamily={'SFProDisplay-Regular'}>
          {displayDateString(userLog.createdAt, true)}
        </Typography>
      </Box>
      <Box
        sx={{ justifyContent: 'space-between', alignItems: 'flex-start' }}
        className='row'
      >
        <Typography fontFamily={'SFProDisplay-Regular'} color='text.secondary'>
          Action:
        </Typography>
        <Typography fontFamily={'SFProDisplay-Regular'}>
          {userLog.action}
        </Typography>
      </Box>
    </Box>
  );
};

export default UserLogCell;
